import { FC } from 'react';
import { Page } from 'layouts/Page';
import { Ppwr } from 'components/Ppwr';

export const PpwrPage: FC = () => {
	return (
		<Page title="PPWR – EAS Control Center">
			<Ppwr />
		</Page>
	);
};
